import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function JobsBoard({ onBack, onPostJob }) {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [type, setType] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/jobs")
      .then((r) => setItems(r.data.items || r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const categories = [
    "All",
    ...Array.from(
      new Set(items.map((x) => x.category).filter(Boolean))
    ),
  ];

  const filtered = items.filter((job) => {
    const q = search.trim().toLowerCase();

    const matchesSearch =
      !q ||
      [
        job.title,
        job.org,
        job.location,
        job.category,
        job.description,
        job.skills,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(q);

    const matchesCategory =
      category === "All" || job.category === category;

    const matchesType =
      type === "All" || job.employment_type === type;

    return matchesSearch && matchesCategory && matchesType;
  });

  const whatsappNumber = (value) =>
    String(value || "").replace(/\D/g, "");

  return (
    <SimplePage title="Local Jobs & Opportunities" onBack={onBack}>
      <div className="jobs-hero-panel">
        <div>
          <span className="jobs-kicker">VIJAYANAGAR JOB CONNECT</span>
          <h2>Find local jobs. Contact employers directly.</h2>
          <p>
            Discover employment opportunities posted for candidates in and
            around Vijayanagar. Contact employers directly by phone,
            WhatsApp, email or their application link.
          </p>
        </div>

        <button className="civic-btn primary" onClick={onPostJob}>
          Post a Job
        </button>
      </div>

      <div className="jobs-disclaimer">
        <strong>For employers:</strong> Job listings are reviewed before
        publication. The portal facilitates listings and direct contact;
        candidates should independently verify employers, job details and
        any requests for money or documents.
      </div>

      <div className="jobs-filters">
        <div className="jobs-search">
          <Search size={18} />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search jobs, skills, companies..."
          />
        </div>

        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          {categories.map((x) => (
            <option key={x}>{x}</option>
          ))}
        </select>

        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option>All</option>
          <option>Full-time</option>
          <option>Part-time</option>
          <option>Contract</option>
          <option>Internship</option>
          <option>Temporary</option>
        </select>
      </div>

      {loading ? (
        <div className="jobs-empty">Loading jobs...</div>
      ) : filtered.length === 0 ? (
        <div className="jobs-empty">
          <BriefcaseBusiness size={34} />
          <h3>No matching jobs found</h3>
          <p>Try another search or category.</p>
        </div>
      ) : (
        <div className="jobs-grid">
          {filtered.map((job, i) => {
            const phone = whatsappNumber(job.employer_phone);

            return (
              <article className="job-card-pro" key={job.id || i}>
                <div className="job-card-top">
                  <div className="job-icon">
                    <BriefcaseBusiness size={22} />
                  </div>

                  <div>
                    <h3>{job.title}</h3>
                    <p className="job-company">
                      {job.org || "Employer"}
                    </p>
                  </div>
                </div>

                <div className="job-meta-grid">
                  {job.location && (
                    <span>
                      <MapPin size={15} />
                      {job.location}
                    </span>
                  )}

                  {job.employment_type && (
                    <span>
                      <BriefcaseBusiness size={15} />
                      {job.employment_type}
                    </span>
                  )}

                  {job.salary && (
                    <span>
                      ₹ {job.salary}
                    </span>
                  )}

                  {job.experience && (
                    <span>
                      {job.experience}
                    </span>
                  )}
                </div>

                {job.category && (
                  <span className="job-category">
                    {job.category}
                  </span>
                )}

                <p className="job-description">
                  {job.description || "Job opportunity available."}
                </p>

                <div className="job-extra">
                  {job.qualification && (
                    <div>
                      <strong>Qualification:</strong>{" "}
                      {job.qualification}
                    </div>
                  )}

                  {job.openings && (
                    <div>
                      <strong>Openings:</strong>{" "}
                      {job.openings}
                    </div>
                  )}

                  {job.deadline && (
                    <div>
                      <strong>Apply before:</strong>{" "}
                      {job.deadline}
                    </div>
                  )}
                </div>

                <div className="job-actions">
                  {job.employer_phone && (
                    <a
                      className="job-action phone"
                      href={`tel:${job.employer_phone}`}
                    >
                      <Phone size={16} />
                      Call
                    </a>
                  )}

                  {phone && (
                    <a
                      className="job-action whatsapp"
                      href={`https://wa.me/${phone}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <MessageCircle size={16} />
                      WhatsApp
                    </a>
                  )}

                  {job.employer_email && (
                    <a
                      className="job-action email"
                      href={`mailto:${job.employer_email}`}
                    >
                      <Mail size={16} />
                      Email
                    </a>
                  )}

                  {job.apply_link && (
                    <a
                      className="job-action apply"
                      href={job.apply_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Apply Online
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      )}
    </SimplePage>
  );
}



function JobsPage(props) { return <JobsBoard {...props} />; }
export default JobsPage;
